import { IconButton } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { MdOutlineRefresh } from 'react-icons/md'
import styled from 'styled-components'
import { ActiveProps } from '../../Layout/CommonStyle'
import { ResultJobsEvaluationsDto } from '../../../models/Dto/ResultJobsEvaluationsDto'
import { RootState, useAppSelector } from '../../../store'
import { axiosPost } from '../../Common/Axios'
import { ApiResult } from '../../../models/Enums'
import ResultGraph from './ResultGraph'
import ResultJob from './ResultJob'
import ResultJobsPopup from '../../Mentee/JobClass/ResultJobsPopup'

function MentorJobClass() {
  const [activeIndex, setActiveIndex] = React.useState(0)
  const [resultJobsEvaluationsDtos, setResultJobsEvaluationsDtos] =
    React.useState<ResultJobsEvaluationsDto[]>([])
  const [resultJobsEvaluationsDto, setResultJobsEvaluationsDto] = useState<
    ResultJobsEvaluationsDto | undefined
  >(undefined)
  const [isPopup, setIsPopup] = useState(false)

  const me = useAppSelector((state: RootState) => state.user.me)
  console.log('me', me)

  const loadResultJobStatistics = async () => {
    const result = await axiosPost(
      '/api/jobs/get_result_jobs_statistics',
      me.groupId
    )

    if (result.apiResult !== ApiResult.SUCCESS) {
      console.log('get_result_jobs_statistics error', result.message)
      return
    }

    console.log('loadResultJobStatistics', result.data)
    setResultJobsEvaluationsDtos(result.data)
  }

  useEffect(() => {
    loadResultJobStatistics()
  }, [me.groupId])

  return (
    <Container>
      {isPopup && (
        <ResultJobsPopup
          setIsPopup={setIsPopup}
          posterUrl={resultJobsEvaluationsDto?.resultJobs.posterUrl || ''}
        />
      )}
      <Tools>
        <IconButton>
          <MdOutlineRefresh onClick={() => loadResultJobStatistics()} />
        </IconButton>
        <SelectDataButton
          active={activeIndex === 0}
          onClick={() => setActiveIndex(0)}
        >
          전체
        </SelectDataButton>
        <SelectDataButton
          active={activeIndex === 1}
          onClick={() => setActiveIndex(1)}
        >
          구체성
        </SelectDataButton>
        <SelectDataButton
          active={activeIndex === 2}
          onClick={() => setActiveIndex(2)}
        >
          흥미성
        </SelectDataButton>
        <SelectDataButton
          active={activeIndex === 3}
          onClick={() => setActiveIndex(3)}
        >
          사회적 필요성
        </SelectDataButton>
      </Tools>
      {resultJobsEvaluationsDtos.length > 0 ? (
        <ResultGraph
          resultJobsEvaluationsDtos={resultJobsEvaluationsDtos}
          activeIndex={activeIndex}
        />
      ) : (
        <NoData>데이터가 없습니다.</NoData>
      )}
      <ResultJobs>
        {resultJobsEvaluationsDtos.map((resultJobsEvaluationsDto) => (
          <ResultJob
            key={resultJobsEvaluationsDto.resultJobs.id}
            resultJobsEvaluationsDto={resultJobsEvaluationsDto}
            resultJobsEvaluationsDtos={resultJobsEvaluationsDtos}
            setResultJobsEvaluationsDtos={setResultJobsEvaluationsDtos}
            setResultJobsEvaluationsDto={setResultJobsEvaluationsDto}
            setIsPopup={setIsPopup}
            useDelete={true}
          />
        ))}
      </ResultJobs>
    </Container>
  )
}

const Container = styled.div`
  margin: 20px auto;
  width: 1200px;
`

const NoData = styled.div`
  margin: 20px auto;
  width: 100%;
  text-align: center;
`
const Tools = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  column-gap: 20px;
`

const SelectDataButton = styled.div`
  border: none;
  color: darkblue;
  cursor: pointer;
  font-weight: ${(props: ActiveProps) => (props.active ? 'bold' : 'normal')};
  text-decoration: ${(props: ActiveProps) => (props.active ? 'underline' : '')};
`

const ResultJobs = styled.div`
  padding: 40px 40px 200px 70px;
`

export default MentorJobClass
